var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.layout === 'secure')?_c('SecureLayout',[_c('router-view',{key:_vm.$route.path})],1):_c('InSecureLayout',{key:_vm.reload},[_c('router-view',{key:_vm.$route.path})],1),_c('GlobalError')],1)}
var staticRenderFns = []

export { render, staticRenderFns }